export const ORG_TYPES = [
  "DTR Property",
  "Resort / Accommodation Group",
  "Marketing Client",
  "Supplier",
  "Business Contact",
  "Distribution Partner – OTA",
  "Distribution Partner – Wholesaler",
  "Distribution Partner – Affiliate",
  "Tourism Body",
  "Corporate Partner",
  "RTO",
  "ITO",
  "Inbound",
  "Other",
];

export const RELATIONSHIP_STATUS = [
  "Key Partner",
  "Standard Partner",
  "Developing Relationship",
  "Prospect",
  "Dormant",
  "Former Partner",
];

export const RELATIONSHIP_HEALTH = ["Strong", "Good", "Needs Attention", "At Risk"];

export const ACTION_TYPES = [
  "Task",
  "Call",
  "Email",
  "Meeting",
  "Other",
];

export const ACTIVITY_TYPES = ["Task", "Call", "Meeting", "Email", "Site Visit", "Event", "Other"];

export const ACTION_SUBTYPES = [
  "Nurture Relationship",
  "Site Visit",
  "Regular Review",
  "Follow-Up",
  "Prospecting / Sales",
  "Famil",
  "Response / Reply",
  "Other",
];

export const ACTION_STATUSES = ["To Do", "In Progress", "Waiting", "Completed", "Cancelled"];
export const OPEN_STATUSES = ["To Do", "In Progress", "Waiting"];
export const STATUS_LABELS = { Waiting: "On Hold / Waiting" };
export const statusLabel = (s) => STATUS_LABELS[s] || s;
export const PRIORITIES = ["Urgent", "High", "Medium", "Low"];
export const PREFERRED_CONTACT = ["Email", "Phone", "Mobile", "In Person"];
export const PROPERTY_STATUS = ["Active", "Inactive", "Prospect", "Onboarding"];
export const VOUCHER_STATUSES = ["Active", "Redeemed", "Expired", "Cancelled"];
export const CONTACT_TITLES = ["Mr", "Mrs", "Ms", "Miss", "Dr", "Prof"];
export const REMINDERS = ["None", "1 day before", "3 days before", "1 week before", "Custom days before", "On a specific date"];
export const RECURRING = ["None", "Daily", "Weekly", "Fortnightly", "Monthly", "Quarterly", "6 Monthly", "Yearly"];

export const SIZE_METRICS = ["Room Nights", "Bookings", "Revenue"];
export const SIZE_PERIODS = ["Monthly", "Annual"];

export const OPPORTUNITY_TYPES = [
  "OTA",
  "Wholesaler",
  "Tourism Partnership",
  "Corporate Agreement",
  "Campaign",
  "Distribution Option",
  "Marketing Client",
  "Other",
];

export const KPI_PERIODS = [{ value: "Weekly", label: "Week" }, { value: "Monthly", label: "Month" }, { value: "Quarterly", label: "Quarter" }, { value: "Annual", label: "Year" }];
export const REPORT_PERIODS = ["This Week", "Last Week", "This Month", "Last Month", "This Quarter", "Last Quarter", "This Year", "Last Year", "All"];
export const ALCOHOL_ORDER_STATUSES = ["New", "Ordered", "Delivered"];
export const PRINT_ORDER_STATUSES = ["Ordered", "On Hold", "In Production", "Dispatched", "Delivered", "Cancelled"];
export const CAMPAIGN_STATUSES = ["New", "In Discussions", "Scheduled", "ON SALE", "Completed", "Extended", "Cancelled"];
export const CAMPAIGN_MARKETS = ["AU", "NZ", "UK", "OTHER"];
export const CAMPAIGN_TYPES = ["Email", "Agent", "Other"];
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const KPI_METRICS = [
  { value: "actions", label: "Completed Actions" },
  { value: "opportunities", label: "New Opportunities" },
  { value: "opportunities_stage", label: "Opportunities Reaching Stage" },
  { value: "pipeline_value", label: "Open Pipeline Value ($)" },
  { value: "agent_campaigns_on_sale", label: "Agent Campaigns Changed to ON SALE" },
  { value: "placements", label: "Property Placements in Agent Campaigns" },
];
export const KPI_STATUS = {
  ahead: { label: "Ahead", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", bar: "bg-emerald-500" },
  on_track: { label: "On track", cls: "bg-sky-50 text-sky-700 border-sky-200", bar: "bg-sky-500" },
  behind: { label: "Behind", cls: "bg-amber-50 text-amber-700 border-amber-200", bar: "bg-amber-500" },
  at_risk: { label: "At risk", cls: "bg-rose-50 text-rose-700 border-rose-200", bar: "bg-rose-500" },
};
